<template>
  <div class="index-page container">
    <n-card>
      <n-table :data="data" :columns="columns" :loading="$var('load')">
        <template #avatar="{item}">
          <n-image centered :src="item.image" />
        </template>
        <template #tools="{item}">
          <n-button icon="eye" flat round @click="$router.push({name: 'images.edit', params: { id: item.id, }})" />
        </template>
      </n-table>
    </n-card>
  </div>
</template>

<script>
export default {
  name: 'Index',
  data: () => ({
    data: [],
    columns: [
      { name: 'avatar', title: 'Изображение', },
      { name: 'title', title: 'Описание', },
      { name: 'tools', title: '', },
    ],
  }),
  mounted() {
    this.loadModels()
  },
  methods: {
    loadModels() {
      this.$var('load', true)
      $api.app.images.get().sort([ 'id,asc', ]).then((response) => {
        this.data = response.data.content
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .index-page {
  
    --n-image-width: 550px;
    --n-image-height: 250px;
  }
</style>
